import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly authTokenKey = 'auth_token';
  private readonly refreshTokenKey = 'refresh_token';
  private readonly selectedOrganizationIdKey = 'admin_selected_organization_id';
  private readonly selectedOrganizationNameKey = 'admin_selected_organization_name';

  getAuthToken(): string | null {
    return localStorage.getItem(this.authTokenKey);
  }

  setAuthToken(token: string): void {
    localStorage.setItem(this.authTokenKey, token);
  }

  clearAuthToken(): void {
    localStorage.removeItem(this.authTokenKey);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(this.refreshTokenKey);
  }

  setRefreshToken(token: string): void {
    localStorage.setItem(this.refreshTokenKey, token);
  }

  clearRefreshToken(): void {
    localStorage.removeItem(this.refreshTokenKey);
  }

  getSelectedOrganizationId(): number | null {
    const raw = localStorage.getItem(this.selectedOrganizationIdKey);
    return raw ? Number(raw) : null;
  }

  getSelectedOrganizationName(): string | null {
    return localStorage.getItem(this.selectedOrganizationNameKey);
  }

  setSelectedOrganization(id: number, name: string): void {
    localStorage.setItem(this.selectedOrganizationIdKey, String(id));
    localStorage.setItem(this.selectedOrganizationNameKey, name);
  }

  clearSelectedOrganization(): void {
    localStorage.removeItem(this.selectedOrganizationIdKey);
    localStorage.removeItem(this.selectedOrganizationNameKey);
  }
}
